<div class="navbar sas-toolbar d-print-none" [hidden]="hideToolbar">
    <nav role="navigation" class="navbar-header sas-toolbar-components" aria-label="Toolbar">
        <ul class="breadcrumb" [innerHTML]="breadcrumbContent"></ul>
        @if(toolbarService.showBackButton()){
        <ul class="nav navbar-nav navbar-left">
            <li>
                <back-button custom-state-back="stateBack" class="d-print-none"></back-button>
            </li>
        </ul>
        }
        @if(toolbarService.showBackToLandpage()){
        <button type="button" class="btn btn-outline-secondary" (click)="navigateBackToLandpage()">
            <i class="fa fa-arrow-left"></i> Back to Landpage
        </button>
        }
        <ul class="nav navbar-nav navbar-right d-flex flex-row align-items-center gap-2">
            <!-- <li class="d-md-block d-lg-none small-sas-language-selector">
          <sas-language-selector [sasLangData]="languages"></sas-language-selector>
        </li> TODO: Update to be responsive -->
            @if (!hideValidationChecklist) {
            <li class="d-none d-lg-block">
                <sas-validation-checklist-control></sas-validation-checklist-control>
            </li>
            }
            <li class="d-none d-lg-block">
                <sas-language-selector [sasLangData]="languages"></sas-language-selector>
            </li>
            @if (!isExternalAuthentication) {
            <li>
                <sas-sign-user></sas-sign-user>
            </li>
            }
        </ul>
    </nav>
</div>

